import React from 'react';
import { ACLAuthorizationRequest } from '@/api/bol';
import { LogisticsObjectFormDialog } from '@/components/common/LogisticsObjectFormDialog';
import { defaultProductTemplate } from '@/utils/productDefaultTemplate';

export interface ProductFormDialogProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (data: { memberIdentifier: string; productJson: string; aclAuthorizations?: ACLAuthorizationRequest[] }) => Promise<void>;
}

export const ProductFormDialog: React.FC<ProductFormDialogProps> = ({
  open,
  onClose,
  onSubmit,
}) => {
  const handleSubmit = async (data: { memberIdentifier: string; jsonData: string; productJson?: string; aclAuthorizations?: ACLAuthorizationRequest[] }) => {
    const transformedData = {
      memberIdentifier: data.memberIdentifier,
      productJson: data.productJson || data.jsonData,
      aclAuthorizations: data.aclAuthorizations,
    };

    await onSubmit(transformedData);
  };

  return (
    <LogisticsObjectFormDialog
      open={open}
      onClose={onClose}
      onSubmit={handleSubmit}
      title="Create New Product"
      jsonFieldName="productJson"
      defaultJsonTemplate={defaultProductTemplate()}
      jsonLabel="Enter a valid Product JSON according to the SDL schema:"
      jsonHelperText="The JSON must conform to the Product schema defined in the BOL API"
      submitButtonText="Create"
    />
  );
};
